import { ETH_ADDRESS } from "../constants";
export const ADDRESSES = {
    "PAIR_LOGIC": {
        "690": "0xa240A3f400dA42Bac720FBab2260Ae11AB50fcB2",
        "84532": "0xda2590462bEA60d3A2067061cf2E63ADd5700aB7"
    },
    "PROXY_ADMIN": {
        "690": "0x8BF4207Ea132D1Ec4655a0531b0a4E5E2521b446",
        "84532": "0x00e654c3A0e2f3cC96dD682ad1cD8Df7698626f7"
    },
    "BANK": {
        "690": "0x836F0b434fF0601f728cB5F2859356c1A235d3D4",
        "84532": "0x483027e27FA7A44c43335d67Cb6ADdeEbfA0e9e0"
    },
    "EXCHANGE": {
        "690": "0xcA738Fe03481846e5c762Aa11E8904fa526d319f",
        "84532": "0x1B1Db412e2aC539C064Ef3E22895B1e2f998D635"
    },
    "BTLY": {
        "690": "0xFF392d3f443b7B3752f9Cf0f40C3D263CB66cdCA",
        "84532": "0x9cd1d1689a08aD33DF731d2E3ff0a8487B5ba385"
    },
    "USDC": {
        "84532": "0x4fe853163A95AC410D388234B87E387352d26B08"
    }
};
export const QUOTE_COINS = {
    "84532": [
        '0x4fe853163A95AC410D388234B87E387352d26B08',
        ETH_ADDRESS,
    ],
    "690": [
        '0xD5d59fC063e7548b6015A36fEb10B875924A19be',
        ETH_ADDRESS,
    ],
    "8453": [
        '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
        '0x820c137fa70c8691f0e44dc420a5e53c168921dc',
        '0x50c5725949a6f0c72e6c4a641f24049a917db0cb',
    ],
    "137": [
        '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
        '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
        '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
    ],
};
export const RATES_ENDPOINTS = {
    "84532": 2,
    "690": 2,
    "8453": 2,
    "137": 2,
};
export const TOKEN_BRIDGES = {
    84532: {
        "0x4fe853163A95AC410D388234B87E387352d26B08": "https://faucet.bitly.exchange"
    },
    690: {
        "0x4200000000000000000000000000000000000006": "https://redstone.xyz/bridge",
        "0xD5d59fC063e7548b6015A36fEb10B875924A19be": "https://redstone.xyz/bridge",
        ETH_ADDRESS: "https://redstone.xyz/bridge",
    },
};
// Number.MAX_SAFE_INTEGER means no limit
export const BATCH_BLOCK_SIZE = {
    "84532": 10000,
    "690": Number.MAX_SAFE_INTEGER,
    "8453": Number.MAX_SAFE_INTEGER,
    "137": Number.MAX_SAFE_INTEGER,
};
